module.exports = __webpack_public_path__ + "static/img-develop-f2da5575d08d8d3de44036baeb7ca993.jpg";